import styles from "../Components/ProductList.module.css";
const HomeServicesItem = ({item}) => {
    return (
        <>
        <div className={`col-md-2 ${styles.ProductCol}`}>
        <div className="card">
        <div id={`carouselExampleControls${item.id}`} className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
  {item.trade_image1 ? 
    <div className="carousel-item active">
    
      <img src={`${global.config.live_url}${item.trade_image1}`} className="d-block w-100" alt="..." /> 
    
    </div> : ''
 }
    
    {item.trade_image2 ? <div class="carousel-item">
      <img src={`${global.config.live_url}${item.trade_image2}`} className="d-block w-100" alt="..." />
    </div>
 : ''
    }
    {item.trade_image3 ?<div class="carousel-item">
      <img src={`${global.config.live_url}${item.trade_image3}`} className="d-block w-100" alt="..." />
    </div> : ''
}
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target={`#carouselExampleControls${item.id}`} data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target={`#carouselExampleControls${item.id}`} data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
  <div className="card-body">
  <h5 className={`card-title ${styles.productName}`}>
                <span className="product-name"><strong>{item.trade_person}</strong></span>
              </h5>
    
  </div>
  <ul className="list-group list-group-flush">
    <li className="list-group-item"><span className="product-weight-unit">
                  Name: {item.name}
                </span></li>
    <li className="list-group-item">Contact no: {item.contact_no}</li>
    <li className="list-group-item">City : {item.city}</li>
  </ul>
  {/* <div class="card-body">
    <a href="#" class="card-link">More details...</a>    
  </div> */}
</div>
          {/* <div className="card">            
            <div className="card-body">
              <h5 className={`card-title ${styles.productName}`}>
                <span className="product-name"><strong>{item.trade_person}</strong></span>
              </h5>
            </div>
            <ul className="list-group list-group-flush">
              <li className="list-group-item"><div id="carouselExampleSlidesOnly" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
  {item.trade_image1 ? 
    <div class="carousel-item active">
    
      <img src={`${global.config.live_url}${item.trade_image1}`} class="d-block w-100" alt="..." /> 
    
    </div> : ''
 }
    
    {item.trade_image2 ? <div class="carousel-item">
      <img src={`${global.config.live_url}${item.trade_image2}`} class="d-block w-100" alt="..." />
    </div>
 : ''
    }
    {item.trade_image3 ?<div class="carousel-item">
      <img src={`${global.config.live_url}${item.trade_image3}`} class="d-block w-100" alt="..." />
    </div> : ''
}
  </div>
</div></li>
              
            
              <li className="list-group-item">
                <span className="product-weight-unit">
                  Name: {item.name}
                </span>
              </li>
              <li className="list-group-item">
                Contact no: {item.contact_no}
              </li>
              <li className="list-group-item">               
                City : {item.city}
                
              </li>
            </ul>
          </div> */}
        </div>
        </>
    );
}
export default HomeServicesItem;